import "./contact.scss";

import React from "react";
import { createRoot } from "react-dom/client";

import { Contact } from "./react";
import { ManagedUIContext } from "./react/context";

document.addEventListener("DOMContentLoaded", async function () {
  const container = document.getElementById("contact-form");
  if (container && window.CONTACT_FORM) {
    const root = createRoot(container);

    root.render(
      <ManagedUIContext>
        <Contact />
      </ManagedUIContext>
    );
  }
});
